import { apiClient, __isNil } from '../../utils';
import { handleError } from '../handleError';

export const editSiteInfo = async ({
  siteId: siteID,
  title,
  siteDescription,
  keywords,
  address,
  email,
  phone,
  enamadLink,
  enamadCode,
  samandehiInfo,
  terms,
  aboutUs,
  frequentlyAsked,
  color,
  footerText,
  contactSupport,
  telegram,
  instagram,
  whatsapp,
  analytics_googleSiteVerification,
  analytics_googleTagManager_gtmId,
  analytics_googleTagManager_GaMeasurementId,
  analytics_alexa,
  analytics_clarity,
  megaMenu,
  search,
}) => {
  try {
    const hasAnalytics =
      analytics_googleTagManager_GaMeasurementId ||
      analytics_googleTagManager_gtmId ||
      analytics_alexa ||
      analytics_googleSiteVerification ||
      analytics_clarity;

    const analytics = hasAnalytics
      ? {
          googleTagManager: {
            GaMeasurementId: analytics_googleTagManager_GaMeasurementId || '',
            gtmId: analytics_googleTagManager_gtmId || '',
          },
          alexa: analytics_alexa || '',
          googleSiteVerification: analytics_googleSiteVerification,
          clarity: analytics_clarity || '',
        }
      : null;

    const data = {
      ...(!__isNil(siteID) ? { siteID } : {}),
      ...(!__isNil(title) ? { title } : {}),
      ...(!__isNil(siteDescription) ? { siteDescription } : {}),
      ...(!__isNil(keywords) ? { keywords } : {}),
      ...(!__isNil(address) ? { address } : {}),
      ...(!__isNil(email) ? { email } : {}),
      ...(!__isNil(phone) ? { phone } : {}),
      ...(!__isNil(enamadLink) ? { enamadLink } : {}),
      ...(!__isNil(enamadCode) ? { enamadCode } : {}),
      ...(!__isNil(samandehiInfo) ? { samandehi: samandehiInfo } : {}),
      ...(!__isNil(terms) ? { terms } : {}),
      ...(!__isNil(aboutUs) ? { aboutUs } : {}),
      ...(!__isNil(frequentlyAsked) ? { frequentlyAsked } : {}),
      ...(!__isNil(color) ? { color } : {}),
      ...(!__isNil(footerText) ? { footerText } : {}),
      ...(!__isNil(contactSupport) ? { contactSupport } : {}),
      ...(!__isNil(telegram) ? { telegram } : {}),
      ...(!__isNil(instagram) ? { instagram } : {}),
      ...(!__isNil(whatsapp) ? { whatsapp } : {}),
      ...(!__isNil(analytics) ? { analytics } : {}),
      ...(!__isNil(megaMenu) ? { menu: megaMenu } : {}),
      ...(!__isNil(search) ? { search } : {}),
    };
    const rsp = await apiClient.post('/merchant/site/edit', { data });
    return rsp;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
